import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CHAT_EXTERNAL_TYPE, INSTAGRAM_REACTIONS } from '../../enum/constants';
import { TReaction } from './reaction.interface';

@Component({
  selector: 'reactions',
  templateUrl: './reactions.component.html',
  styleUrls: ['./reactions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReactionsComponent {
  @Input() chatType?: CHAT_EXTERNAL_TYPE;
  @Output() onChangeReaction = new EventEmitter<TReaction>();

  get availableReactions(): TReaction[] {
    if (this.chatType === CHAT_EXTERNAL_TYPE.INSTAGRAM) {
      return Object.values(INSTAGRAM_REACTIONS);
    }
    return [];
  }

  changeReaction(reaction: TReaction) {
    this.onChangeReaction.emit(reaction);
  }
}
